export default __webpack_public_path__ + "static/words-be8b984337691d6cef9319c964d96ad9.png";